import { render, staticRenderFns } from "./payCode.vue?vue&type=template&id=0a757c51&scoped=true&"
import script from "./payCode.vue?vue&type=script&lang=js&"
export * from "./payCode.vue?vue&type=script&lang=js&"
import style0 from "./payCode.vue?vue&type=style&index=0&id=0a757c51&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a757c51",
  null
  
)

export default component.exports